import { http } from "./http";
import { DashboardOverview } from "../types/dashboard";
import {
  CustomerCartEmailSendResponse,
  CustomerCartEmailSettings,
  CustomerCartListResponse,
  MarketingEmailCaptureListResponse,
  WebsiteVisitDetailResponse,
  WebsiteVisitListResponse,
} from "../types/websiteVisits";

export const DashboardAPI = {
  async getOverview() {
    const response = await http.get<DashboardOverview>("/admin/dashboard/overview");
    return response.data;
  },

  async getWebsiteVisits(params?: { page?: number; limit?: number }) {
    const response = await http.get<WebsiteVisitListResponse>(
      "/admin/dashboard/website-visits",
      {
        params: {
          page: params?.page ?? 1,
          limit: params?.limit ?? 20,
        },
      }
    );
    return response.data;
  },

  async getWebsiteVisitDetail(visitorKey: string) {
    const response = await http.get<WebsiteVisitDetailResponse>(
      `/admin/dashboard/website-visits/${encodeURIComponent(visitorKey)}`
    );
    return response.data;
  },

  async getEmailCaptures(params?: { page?: number; limit?: number }) {
    const response = await http.get<MarketingEmailCaptureListResponse>(
      "/admin/dashboard/email-captures",
      {
        params: {
          page: params?.page ?? 1,
          limit: params?.limit ?? 20,
        },
      },
    );
    return response.data;
  },

  async getCustomerCarts(params?: {
    page?: number;
    limit?: number;
    search?: string;
    emailStatus?: "all" | "sent" | "unsent";
  }) {
    const response = await http.get<CustomerCartListResponse>(
      "/admin/dashboard/customer-carts",
      {
        params: {
          page: params?.page ?? 1,
          limit: params?.limit ?? 25,
          search: params?.search || undefined,
          emailStatus:
            params?.emailStatus && params.emailStatus !== "all"
              ? params.emailStatus
              : undefined,
        },
      },
    );
    return response.data;
  },

  async removeCustomerCart(id: string) {
    const response = await http.delete<{ ok: boolean; id: string }>(
      `/admin/dashboard/customer-carts/${encodeURIComponent(id)}`,
    );
    return response.data;
  },

  async getCustomerCartEmailSettings() {
    const response = await http.get<{ settings: CustomerCartEmailSettings }>(
      "/admin/dashboard/customer-carts/email-settings",
    );
    return response.data.settings;
  },

  async updateCustomerCartEmailSettings(settings: CustomerCartEmailSettings) {
    const response = await http.put<{ settings: CustomerCartEmailSettings }>(
      "/admin/dashboard/customer-carts/email-settings",
      settings,
    );
    return response.data.settings;
  },

  async sendCustomerCartEmails(input: {
    cartIds?: string[];
    search?: string;
    limit?: number;
    subject?: string;
    message?: string;
    couponCode?: string;
  }) {
    const response = await http.post<CustomerCartEmailSendResponse>(
      "/admin/dashboard/customer-carts/email",
      input,
    );
    return response.data;
  },
};
